const categoriesTriggers = document.querySelectorAll('.js-categories-trigger')

if (categoriesTriggers.length) {
  const categoriesSlider = new Flickity('#js-categories-slider', {
    cellAlign: 'left',
    pageDots: false,
    contain: true,
    imageLoaded: true,
    lazyLoad: true,
    wrapAround: true,
    draggable: false,
    autoPlay: 3000,
    prevNextButtons: false,
    setGallerySize: false,
    pauseAutoPlayOnHover: false,
  })

  categoriesTriggers.forEach((item) => {
    item.addEventListener('click', (event) => {
      categoriesSlider.stopPlayer()
      categoriesSlider.select(parseInt(item.getAttribute('data-slide')) - 1)
    })
  })
}
